<template>
  <div v-if="tiles">
        <h2 class="mb-5 mt-5">Selected words</h2>

        <v-row>
          <template v-for="card in tiles">
            <v-col cols="4" v-if="card.type == 'Word'" :key="`word-${card.el}`">
              <div class="guage">
                <div class="guage__percent">
                  <div
                    class="guage__percent__bar"
                    :style="{ width: card.percentage }"
                  >
                    <p>{{ card.title }}</p>
                  </div>
                </div>
              </div>
            </v-col>
          </template>
        </v-row>
      </div>
</template>

<script>


export default {
  name: "TilesWords",
  props: {
    tiles: {
      type: Array,
      default: null,
    },
  }
};
</script>
